import React from 'react';

const Header = () => (
  <div className="header">
    <p className="logo">
      <span className="blu">Ver</span>
      <span className="purp">sus</span>
    </p>
    <p className="subtitle">Voting made easy</p>
  </div>
);

export default Header;